export const AUTH_EVENT_KIND = 24242;
